module.exports = __webpack_public_path__ + "media/images/new_home/sponsor-logo-4-7bdeee2f16ddfbbc8f320622a510e241.png";